module.exports = __webpack_public_path__ + "img/Ki.451fd5be.svg";